import React from 'react';

const VehicleSpecs = ({ specs }) => (
  <div className="specs-grid">
    {Object.entries(specs).map(([key, value]) => (
      <div className="spec-item" key={key}>
        <span className="spec-label">{key}</span>
        <span className="spec-value">{value}</span>
      </div>
    ))}
  </div>
);

export default VehicleSpecs;
